import styles from './bronnoysund-details-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { useGetRequestNewHook } from '../requestUtils';
import { Box, CheckboxLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { BronnoysundCompany } from '../_models/BronnoysundCompany';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface BronnoysundDetailsExpandProps { }

export function BronnoysundDetailsExpand(props: any) {
  const { t } = useTranslation();
  const { data }: { data: BronnoysundCompany } = useGetRequestNewHook(`admin/BronnoysundCompanies/${props.data.orgNr}`, undefined);
  return (
    <Box className="p-4">
      {data && <Row>
        <Col md={6} xxl={4}>
          <div className="d-flex flex-column mb-3">
            <TextField
              value={data.navn}
              fullWidth
              label={t("standard.companyName")}
              disabled
              className='mb-3'
            />
            <TextField
              value={data.organisasjonsnummer}
              fullWidth
              label={t("standard.organisationNumber")}
              disabled
              className='mb-3'
            />
            <TextField
              value={data.antallAnsatte}
              fullWidth
              label={t("bronnoysundDetails.numberOfEmployees")}
              disabled
              type='number'
              className='mb-3'
            />
          </div>
        </Col>
        <Col md={6} xxl={4}>
          <div className="d-flex flex-column mb-3">
            <TextField
              value={data.forretningsadresse.adresse[0]}
              fullWidth
              label={t("standard.address")}
              disabled
              className='mb-3'
            />
            <TextField
              value={data.forretningsadresse.postnummer}
              fullWidth
              label={t("bronnoysundDetails.postalCode")}
              disabled
              className='mb-3'
            />
            <TextField
              value={data.forretningsadresse.poststed}
              fullWidth
              label={t("bronnoysundDetails.city")}
              disabled
              className='mb-3'
            />
            <TextField
              value={data.forretningsadresse.kommune}
              fullWidth
              label={t("bronnoysundDetails.district")}
              disabled
              className='mb-3'
            />
          </div>
        </Col>
        <Col md={6} xxl={4}>
          <div className="d-flex flex-column mb-3">
            <CheckboxLabel
              label={t("bronnoysundDetails.bankrupt")}
              checked={data.konkurs}
              disabled={true}
            />
            <CheckboxLabel
              label={t("bronnoysundDetails.liquidating")}
              checked={data.underAvvikling}
              disabled={true}
            />
          </div>
        </Col>
      </Row>}
    </Box >
  );
}

export default BronnoysundDetailsExpand;